<template>
    <div>
    <md-dialog-confirm
      :md-active.sync="showDialog"
      md-title="Are you sure you want to delete this circle?"
      md-content="Please be aware that once this circle is deleted, all associated data will be permanently removed. This action cannot be undone."
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="cancel()"
      @md-confirm="deleteCircleRow(circle._id)" />

    <md-button class="picker-icon picker-name" @click="showDialog = true">
        <font-awesome-icon class='small-icon picker-icon-danger' icon="minus-circle"
        aria-hidden="true" /> <span class="delete-circle">Remove Circle</span>
    </md-button>
  </div>
</template>

<script>
import API from "../services/API";
export default {
	name: "DeleteCircleConfirm",
	props: ['circle', "community", "value"],
	data: () => ({
		api: new API(),
		showDialog: false,
		selectedCircle: null,
		circleName: [],
		circles: []
	}),
	methods: {
		cancel: function () {
			this.showDialog = false;
			// this.selectedCircle = null;
		},
		deleteCircleRow: async function (index) {
            if (this.circle && index && this.community) {
				await this.api.put(`communities/process-circle/${this.community}`, {action: 'delete', circle: {short: this.circle.short}}).then(response => {
					this.$emit("reload-data")
				});

			} else {
				this.$emit("reload-data")
			}


		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/DeleteCircleConfirm.vue